//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { upSettlementType as _upSettlementType } from '@/api/order';
export default {
  name: 'AddRemarkDialog',
  props: {},
  data: function data() {
    return {
      commissionTypeDialog: false,
      formOrder: {
        commission_type: ''
      },
      order_id: '',
      flag: false
    };
  },
  methods: {
    upSettlementType: function upSettlementType() {
      var _this = this;
      this.$refs.formOrder.validate(function (valid) {
        if (valid) {
          _upSettlementType({
            order_id: _this.order_id,
            commission_type: _this.formOrder.commission_type
          }).then(function (res) {
            _this.$message({
              message: '操作成功',
              type: 'success'
            });
            _this.commissionTypeDialog = false;
            _this.$emit('upSettlementTypeSuccess', _this.flag);
          });
        }
      });
    }
  }
};